"use strict";
function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;
//# sourceMappingURL=_stackHas.js.map